import { makeImmutable } from "../core";
export class PPhoto {
    constructor(url, alt, aiProvenance = null) {
        this.url = url;
        this.alt = alt;
        this.aiProvenance = aiProvenance;
        makeImmutable(this);
    }
}
